import type { ReactDatePickerCustomHeaderProps } from 'react-datepicker';

import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';

type Props = ReactDatePickerCustomHeaderProps;

export const CustomHeader = ({ monthDate }: Props) => {
  return (
    <div className="flex items-center px-2 py-3">
      <span className="grow text-center text-m font-medium">
        {format(monthDate, 'LLLL', { locale: enUS })}
      </span>
    </div>
  );
};
